<template>
    <div class="mt-2" v-if="pxfLegalMentionsText">
        <span class="fw-bold small" v-html="pxfLegalMentionsText" />
    </div>
</template>

<script>
export default {
    name: "PxfDescription",
    props: {
        pxfLegalMentionsText: {
          type: String,
          default: undefined
        }
    }
}
</script>

<style scoped>

</style>
